import React from "react"

// components
import { Typography, Avatar, Flex } from "antd"

const Logo = () => {
  return (
    <Flex align="center" gap={1} style={{ display: "inline-flex" }}>
      <Avatar shape="square" size={20} src="./foodrestos.png" />
      <Typography.Text strong style={{ margin: 0, fontStyle: "italic" }}>
        Foodrestos
      </Typography.Text>
    </Flex>
  )
}

export default Logo
